// extracted by mini-css-extract-plugin
export default {"View":"View_View__xRmQb","constr":"View_constr__8oMyD"};